"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _app = require("./app");
Object.keys(_app).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _app[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _app[key];
    }
  });
});
var _defaultTranslations = require("./defaultTranslations");
Object.keys(_defaultTranslations).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _defaultTranslations[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _defaultTranslations[key];
    }
  });
});
var _urls = require("./urls");
Object.keys(_urls).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _urls[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _urls[key];
    }
  });
});
//# sourceMappingURL=index.js.map